import { Expose, Transform } from 'class-transformer';
import { Model } from './model';
import * as QuranJSON from '../../../../assets/quran/quran-list.json';

export class SessionsRecordModel extends Model {
  @Expose() assignmentValue: number;
  @Expose() comment: string;
  @Expose() commentIDs: string[];
  @Expose() comments: string[];
  @Expose()
  @Transform(({ value }) => {
    return transformSurahName(value);
  })
  fromSurah: string;
  @Expose() fromVerse: string;
  @Expose() hesitationErrorCount: string;
  @Expose() isDone: boolean;
  @Expose() isExpanded: boolean;
  @Expose() isLesson: boolean;
  @Expose()
  @Transform(({ value }) => {
    return transformSurahName(value);
  })
  toSurah: string;
  @Expose() rate: number;
  @Expose() studentLevel: string;
  @Expose() tajweedErrorCount: number;
  @Expose() toVerse: string;
  @Expose() type: string;
  @Expose() pathKey: string;
  @Expose() wordErrorCount: number;
}

export function transformSurahName(value: string): string {
  const { suras } = QuranJSON;
  if (value && !isNaN(+value)) {
    return suras.find((surah) => (surah.index == `${value}`)).name;
  } else {
    return value;
  }
}
